<template>
  <div>
    <div ref="printableArea" class="section-cashcalc endday px-2" v-if="summary">
      <h2 class="ttl2 popup-header">{{ $gettext('Month report') }} - {{ monthYear }}</h2>
      <div class="text-center">{{ $gettext('Location') }}: <b>{{ summary.location.name }}</b></div>
      <div class="row">
        <div class="col-md-7 pr-md-0">
          <table class="table table-border-outline">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>bill</th>
              <th v-translate>amount</th>
              <th v-translate>cash</th>
              <th v-translate>credit</th>
              <th v-translate>other</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-left">
                <span v-translate>Close</span>
                ({{ summary.bills[1].count }})</td>
              <td>{{ summary.bills[1].amount | currency }}</td>
              <td>{{ summary.bills[1].cash | currency }}</td>
              <td>{{ summary.bills[1].card | currency }}</td>
              <td>{{ summary.bills[1].other | currency }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left"> <span v-translate>Open</span> ({{ summary.bills[0].count }})</td>
              <td>{{ summary.bills[0].amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left"> <span v-translate>Void</span> ({{ summary.bills[2].count }})</td>
              <td>{{ summary.bills[2].amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>tax / charges</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(value, charge) in summary.chargeData" >
              <td>{{ charge }}</td>
              <td>{{ value | currency }}</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>do payment</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(group, groupIndex) in tablePayment">
              <tr @click="group.open = !group.open" :class="{ opened: group.open == true }" class="tr-parent">
                <td>
                  <span class="icon-expanded"></span>
                  <span>{{ group.name }} ({{ group.payments.length }})</span>
                </td>
                <td>{{ group.total | currency }}</td>
              </tr>
              <tr v-show="group.open" v-for="(payment, paymentIndex) in group.payments" class="tr-child">
                <template>
                  <td >{{ payment.expenseCategoryName }} - {{ payment.note }}</td>
                  <td>{{ payment.amount | currency }}</td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>Commission</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="commission in tableCommission">
              <tr @click="commission.open = !commission.open" :class="{ opened: commission.open == true }" class="tr-parent">
                <td>
                  <span class="icon-expanded"></span>
                  <span>{{ commission.name }} ({{ commission.payments.length }})</span>
                </td>
                <td>{{ commission.total | currency }}</td>
              </tr>
              <tr v-show="commission.open" v-for="com in commission.payments" class="tr-child">
                <template>
                  <td ><translate>Staff</translate> #{{ com.note }}</td>
                  <td>{{ com.amount | currency }}</td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>discount</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <tr class="tr-parent">
              <td>
                <span>Credited back line value</span>
              </td>
              <td>{{ summary.overall['Credited back line value'] | currency }}</td>
            </tr>
            <tr class="tr-parent">
              <td>
                <span>Promotions value (discount value)	</span>
              </td>
              <td>{{ summary.overall['Promotion(discount) value'] | currency }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-5">
          <table class="table table-shift-report">
            <tbody>
            <tr>
              <td v-translate>Sales result</td>
              <td>{{ summary.bills[1].amount | currency }}</td>
            </tr>
            <tr>
              <td v-translate>Payments (money-in)</td>
              <td>{{ summary.overall['Payments(money-in)'] | currency }}</td>
            </tr>
            <tr>
              <td v-translate>Payments (money-out)</td>
              <td>{{ summary.overall['Payments(money-out)'] | currency }}</td>
            </tr>
            <tr>
              <td v-translate>Commissions Paid</td>
              <td>{{ summary.overall['Commission paid'] | currency }}</td>
            </tr>

            <tr class="bg-hightlight">
              <td v-translate>Total</td>
              <td>{{ summary.overall['Total day'] | currency }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DayService from '@/services/DayService';
import { SET_CONFIRM_MODAL } from '@/store/mutation-types';
import { mapState } from 'vuex';

const pendingMonthlyAcks = new Map();

export default {
  name: 'MonthReport',
  data() {
    return {
      summary: null,
      tablePayment: [],
      tableCommission: [],
      month: '',
      delivery: null,
      deliveryContext: null,
      deliveryScope: null,
    };
  },
  computed: {
    ...mapState({
      workDay: state => state.auth.user.workDay,
    }),
    monthYear() {
      return this.$dayjs(this.month).format('YYYY-MM');
    },
  },
  methods: {
    async print() {
      const storageKey = this.deliveryScope;
      const failures = [];
      let report = null;
      try {
        report = await this.$store.dispatch(
          'createPdf',
          {
            element: this.$refs.printableArea,
            reportType: 'monthReport',
            startTime: this.$dayjs(this.month),
          },
        );
        if (!report || !report.file) throw new Error(this.$gettext('Monthly PDF creation failed'));
      } catch (error) {
        report = null;
        failures.push(error);
      }
      const pdfOnly = this.delivery && this.delivery.pdfOnly === true;
      if (pdfOnly && !report) {
        this.summary = null;
        this.delivery = null;
        this.deliveryScope = null;
        throw new Error(this.$gettext('Monthly PDF creation failed; storage recovery remains pending'));
      }
      // Keep the download independent of printer availability and API upload.
      if (report && !pdfOnly) {
        try {
          await report.pdf.save(report.name, { returnPromise: true });
        } catch (error) {
          failures.push(error);
        }
      }
      try {
        this.assertDeliveryContext();
        const data = await DayService.printMonthReport({
          summary: JSON.stringify(this.summary),
          ...(report ? {
            pdf: report.file,
            message: report.message,
            fileName: report.name,
          } : {}),
          ...(this.delivery || {}),
          ...(pdfOnly ? { operation: 'store-pdf' } : {}),
        });
        const jobs = Array.isArray(data) ? data : data && data.jobs;
        if (!Array.isArray(jobs)) {
          throw new Error((data && (data.error || data.message)) || this.$gettext('Monthly report upload failed'));
        }
        if (this.delivery && (!data.delivery
            || data.delivery.reportMonth !== this.delivery.reportMonth
            || data.delivery.pdfOnly !== this.delivery.pdfOnly
            || (!this.delivery.pdfOnly && data.delivery.claimToken !== this.delivery.claimToken))) {
          throw new Error(this.$gettext('Monthly delivery claim does not match the report'));
        }
        if (pdfOnly) {
          if (data.pdfStored !== true) {
            throw new Error(data.storageError || this.$gettext('Monthly PDF storage failed'));
          }
        }
        const submitted = !Array.isArray(data) && data.submitted === true;
        const transportSent = !Array.isArray(data) && data.transportSent === true;
        if (!pdfOnly && !submitted && !transportSent && !this.delivery) {
          await this.$store.dispatch('print', { jobs, interactive: false });
        }
        if (!pdfOnly && !submitted && this.delivery) {
          if (!transportSent) {
            this.assertDeliveryContext();
            try {
              await this.$store.dispatch('print', { jobs, interactive: false });
            } catch (error) {
              if (error && error.definitive === true) {
                try {
                  await DayService.acknowledgeMonthlyReport({
                    operation: 'release',
                    reportMonth: this.delivery.reportMonth,
                    claimToken: this.delivery.claimToken,
                  });
                } catch (releaseError) {
                  // Preserve the original transport failure for the caller.
                }
              }
              throw error;
            }
          }
          {
            const ack = { ...this.delivery, ...this.deliveryContext, transportSent: true };
            if (!ack.reportMonth || !ack.claimToken) {
              throw new Error(this.$gettext('Monthly delivery acknowledgement data is missing'));
            }
            pendingMonthlyAcks.set(storageKey, ack);
            try {
              localStorage.setItem(storageKey, JSON.stringify(ack));
            } catch (error) {
              // The module-level marker survives route changes if storage fails.
            }
            this.assertDeliveryContext();
            const ackResult = await DayService.acknowledgeMonthlyReport({
              operation: 'acknowledge',
              reportMonth: ack.reportMonth,
              claimToken: ack.claimToken,
            });
            if (!ackResult || ackResult.result !== true) {
              throw new Error(this.$gettext('Monthly delivery acknowledgement failed'));
            }
            pendingMonthlyAcks.delete(storageKey);
            try { localStorage.removeItem(storageKey); } catch (error) { /* already acknowledged */ }
          }
        }
        if (!pdfOnly && report && data.pdfStored === false) {
          failures.push(new Error(data.storageError || this.$gettext('Monthly PDF storage failed')));
        }
      } catch (error) {
        failures.push(error);
      } finally {
        this.summary = null;
      }
      if (failures.length) {
        throw new Error(failures.map(error => (error && (error.message || error.error)) || String(error)).join('; '));
      }
    },
    deliveryStorageKey() {
      const api = process.env.VUE_APP_API_URL || `https://${window.location.hostname}/api`;
      const user = this.$store.state.auth.user || {};
      const location = user.location || {};
      return `pos_monthly_delivery_ack:${api}:${location.id || 'unknown'}`;
    },
    assertDeliveryContext() {
      if (!this.deliveryContext) return;
      const user = this.$store.state.auth.user || {};
      const location = user.location || {};
      const station = user.station || {};
      if (String(location.id) !== String(this.deliveryContext.locationId)
          || String(station.id) !== String(this.deliveryContext.stationId)) {
        throw new Error(this.$gettext('Monthly delivery session changed'));
      }
    },
    async getAutomaticSummary() {
      const deadline = Date.now() + 120000;
      const maxAttempts = 25;
      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        this.assertDeliveryContext();
        if (Date.now() >= deadline) return [];
        const summary = await DayService.getMonthReport({ automatic: true });
        this.assertDeliveryContext();
        if (Array.isArray(summary) && summary.length === 0) return summary;
        if (summary && Object.prototype.hasOwnProperty.call(summary, 'pending')) {
          if (summary.pending !== true || summary.reason !== 'summaries_pending'
              || !Number.isFinite(summary.retryAfterMs)
              || summary.retryAfterMs < 1 || summary.retryAfterMs > 1000) {
            throw new Error(this.$gettext('Invalid monthly summary readiness response'));
          }
          const waitMs = Math.min(Math.max(summary.retryAfterMs, 5000), deadline - Date.now());
          if (attempt + 1 >= maxAttempts || waitMs < 1) {
            return [];
          }
          await new Promise(resolve => setTimeout(resolve, waitMs));
          continue;
        }
        return summary;
      }
      return [];
    },
    async getMonthReport(startTime = null, endTime = null, automatic = false) {
      const user = this.$store.state.auth.user || {};
      this.deliveryContext = automatic ? {
        locationId: user.location && user.location.id,
        stationId: user.station && user.station.id,
      } : null;
      const storageKey = this.deliveryStorageKey();
      let savedAck = automatic ? pendingMonthlyAcks.get(storageKey) : null;
      if (automatic && !savedAck) {
        try { savedAck = localStorage.getItem(storageKey); } catch (error) {
          throw new Error(this.$gettext('Unable to read pending monthly delivery state'));
        }
      }
      if (automatic && savedAck) {
        let ack;
        if (typeof savedAck === 'string') {
          try { ack = JSON.parse(savedAck); } catch (error) {
            throw new Error(this.$gettext('Pending monthly delivery state is invalid'));
          }
        } else {
          ack = savedAck;
        }
        if (!ack || !ack.reportMonth || !ack.claimToken || ack.transportSent !== true) {
          throw new Error(this.$gettext('Pending monthly delivery state is invalid'));
        }
        const currentUser = this.$store.state.auth.user || {};
        if (ack.locationId != null && String(ack.locationId) !== String(currentUser.location && currentUser.location.id)) {
          throw new Error(this.$gettext('Pending monthly delivery belongs to another session'));
        }
        if (ack) {
          this.assertDeliveryContext();
          const result = await DayService.acknowledgeMonthlyReport({
            operation: 'acknowledge',
            reportMonth: ack.reportMonth,
            claimToken: ack.claimToken,
          });
          if (!result || result.result !== true) {
            throw new Error(this.$gettext('Monthly delivery acknowledgement failed'));
          }
          if (result && result.result === true) {
            pendingMonthlyAcks.delete(storageKey);
            try { localStorage.removeItem(storageKey); } catch (error) { /* already acknowledged */ }
          }
        }
      }
      let force = false;
      let summary;
      if (automatic) {
        this.assertDeliveryContext();
        summary = await this.getAutomaticSummary();
        this.assertDeliveryContext();
        if (Array.isArray(summary) && summary.length === 0) return;
        const delivery = summary && summary.delivery;
        const pdfOnly = delivery && delivery.pdfOnly === true;
        if (!summary || !delivery || delivery.reportMonth !== summary.monthYear
            || (!pdfOnly && !delivery.claimToken)
            || (pdfOnly && delivery.claimToken)) {
          throw new Error((summary && (summary.error || summary.message)) || this.$gettext('Monthly report unavailable'));
        }
        this.delivery = summary.delivery;
        this.assertDeliveryContext();
        this.deliveryScope = storageKey;
        startTime = summary.monthYear;
      } else if(!startTime) {
        this.delivery = null;
        startTime = this.$dayjs(this.workDay.startTime).format('YYYY-MM-DD');
      } else {
        this.delivery = null;
        force = true;
      }
      if(!endTime) {
        endTime = this.$dayjs().format('YYYY-MM-DD');
      }
      if (!automatic) {
        summary = await DayService.getMonthReport({ startTime, endTime, force });
      }
      if (Array.isArray(summary) && summary.length === 0) return;
      if (!summary || !Array.isArray(summary.moneyIns) || !Array.isArray(summary.moneyOuts)
          || !Array.isArray(summary.commissionList) || !Array.isArray(summary.payCommissions)) {
        throw new Error((summary && (summary.error || summary.message)) || this.$gettext('Monthly report unavailable'));
      }
      if (summary) {
        this.month = summary.monthYear;
        this.summary = summary;
        this.tablePayment = [
          {
            name: this.$gettext('Money-in'),
            payments: this.summary.moneyIns,
            total: this.summary.moneyIns.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
          {
            name: this.$gettext('Money-out'),
            payments: this.summary.moneyOuts,
            total: this.summary.moneyOuts.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
        ];
        this.tableCommission = [
          {
            name: this.$gettext('Earned Commission'),
            payments: this.summary.commissionList,
            total: this.summary.commissionList.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
          {
            name: this.$gettext('Paid Commission'),
            payments: this.summary.payCommissions,
            total: this.summary.payCommissions.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
        ];
        await this.$nextTick();
        await this.print();
      }
    },
  },
};
</script>
